import { useMutation } from 'react-query'
import { useParams } from 'react-router-dom'
import JourneyService from 'src/services/journeys.service'

export const useCheckJourneyCodeExist = () => {
  const { accountId, id } = useParams()

  return useMutation(async (code: string) => JourneyService.checkCodeExist(code, id!, accountId!))
}
